export const GridHeight = '100%';
export const GridWidth = '100%';

export const Width_1000 = 1000;
export const Width_40 = 40;
export const Width_80 = 80;
export const Width_50 = 50;
export const Width_150 = 150;
export const Width_200 = 200;
export const Width_300 = 300;
export const Width_600 = 600;
export const Width_250 = 250;
export const Length_30 = 30;
export const Length_10 = 10;
export const Length_255 = 255;
export const BorderColor = '#D6D2D0';
export const MinDate = new Date('01/01/1991');
export const MaxDate = new Date('12/31/9999');
export const dateFormat = 'MM/DD/YYYY';
export const dateFormatForDatePicker = 'MM/dd/yyyy';
export const dateFormatDatePicker = 'mm/dd/yyyy';
export const receivedDateDays = 30;
export const viewPortHeight = 'auto';
export const viewPortHeight_350 = 400;
export const viewPortHeight_350_cbi = 350;
export const tableGridHight350 = 350;
export const tableGridHight330 = 330;

export const viewPortHeight_355 = 355;
export const viewPortHeight_380 = 380;
export const viewPortHeight_620 = 620;
export const viewPortHeight_300 = 300;
export const viewPortHeight_200 = 200;
export const viewPortHeight_250 = 250;

export const DefaultPlanType = 'FD';
export const planTypeMedicaid = 'Medicaid';
export const radioGroupLabelNamePlan = 'Plan Type';
export const rebateProgramLabelName = 'Rebate Program';
export const radioGroupLabelNameSearchType = 'Search Type';
export const radioGroupLabelNameSelectBy = 'Select By';
export const quarterLabelName = 'Quarter';
export const radioGroupLabelNameAudit = 'Audit Types';
export const radioGroupLabelNameDisputes = 'Assignment';
export const radioGroupQuarterNameDisputes = 'Quarter Range';
export const radioGroupQuarterDisputes = 'Report Quarter Option';
export const radioGroupPaymentGenerate = 'Payment Status';
export const checkboxDisputeOverdue = 'Overdue Only';
export const checkboxDisputeContact = 'Show all disputes for Dispute Contact';
export const radioGroupInconsistencies = 'Show Inconsistencies';
export const tabRadioInconsistencies = 'View Details';
export const radioGroupLabelNameSelectedBy = 'Select By';
export const SUCCESS_MSG = 'SUCESS';
export const STATUS_MSG = '001';
export const ALLOCATE_PAYMENT_DETAIL_SCREEN_URL = '/allocatePaymentDetail/';
export const checkBoxPriorQtrUra =
  'If zero URA, use prior qtr URA in calculation';
export const radioGroupLabelNameSelectOpt = 'Select Option';
export const reportQuarterOption = 'Report Quarter Option';
export const ROSI_PQAS_ALERT_TITLE = 'ROSI/PQAS';
export const DEFAULT_COLUMN_PQAS_ROSI = 'ndc';
export const SAVE_AGAIN_ALERT_MESSAGE =
  "ROSI/PQAS has not yet completed calculations based on your last modification, please try saving again.(You can prevent this message in the future by tabbing out of the last field you've modified, before saving.)";

export const filterChecksByRadioButtonList = [
  { name: 'No Filter (Show All)', value: 'noFilter' },
  { name: 'Logged By Me', value: 'loggedByMe' },
  { name: 'Logged By Others', value: 'loggedByOther' },
  { name: 'Batch Date', value: 'batchDt' },
  { name: 'Check Date', value: 'checkDt' },
  { name: 'Postmark Date', value: 'postmarkedDt' },
  { name: 'Received Date', value: 'receivedDt' },
];
export const AllocateFromRadioButtonList = [
  { name: 'Check', value: 'Check' },
  { name: 'Credit', value: 'Credit' },
];
export const filterSelectByList = [
  { name: 'Program, Quarter and Manufacturer', value: 'PQM' },
  { name: 'Invoice Number', value: 'IN' },
];
export const beginPrintingOptionList = [
  { name: 'Print Invoices AND Mailing Labels', value: 'both' },
  { name: 'Print Invoices', value: 'printInvoices' },
  { name: 'Mailing Labels', value: 'mailingLabels' },
];
export const remotePrinterOptions = [
  { name: 'Local Printing', value: 'localPrinting' },
  { name: 'Remote Printing', value: 'remotePrinting' },
];
